// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VDoKmu{position:absolute;bottom:12px;height:16px}html[dir='ltr'] .VDoKmu{right:12px}html[dir='rtl'] .VDoKmu{left:12px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VDoKmu`
};
export default ___CSS_LOADER_EXPORT___;
